<style lang="stylus" scoped>
@import '../css/var'
.container
  background-color white
  border-radius pt(15)
  width 217px
  height 217px
  
.tile-image
  width 64px
  height 64px
  margin-top 40px
  object-fit cover

.title
  margin-top 5px
  font-size 30px
  color $normal-text-color
</style>
<template>
  <a class="container" @click="$emit('click')">
    <div  align="center">
      <img :src="src" class="tile-image">
      <div class="title">{{content}}</div>
    </div>
  </a>
</template>
<script>
export default {
  props: {
    src: '',
    content: ''
  }
}
</script>


// WEBPACK FOOTER //
// tile.vue?70ca133c